import React from "react";
import "./index.css";
import { useTranslation } from "react-i18next";

export default function RescheduleAppointmentNotAllowModel({ deleteUser,cancelRequest, id,label }) {
  const { t } = useTranslation("clientMisc");
  return (
    <div className="confirm-delete-wrapper ConfirmReschedule register-medium">
      <div data-backdrop="static" className="modal fade" id={id} role="dialog">
        <div className="modal-dialog padding-unset modal-dialog-preview">
          <div className="modal-content">
            <div className="modal-body">
              <div className="icon-pop">
                <img src="images/Union-icon.png" alt="Union-icon" />
              </div>
              <h3 className="rescheduleText">{label}</h3>
              <div className="confirm-btn-box">
                <div
                  className="register-medium-confirnation"
                  onClick={cancelRequest}
                  data-dismiss="modal"
                >
                  {t("appointmentNotAllowed.okay")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
